import {
  DECREASEQUANTITY,
  DELETEPRODUCTCART,
  INCREASEQUANTITY
} from "./actionTypes";
import { initialState } from "./initialState";

export const nextQunatityCart = (carts) => {
    const maxId = carts.reduce(
      (maxId, cart) => Math.max(+cart?.productId, +maxId),
      -1
    );
    return +maxId + 1;
  };
const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case DECREASEQUANTITY:
      const { productId, quantity } = action.payload;
      return state.map((product) => {
        if (product.productId !== productId) {
          return product;
        }
        return {
          ...product,
          quantity: +quantity - 1,
        };
      });
    case DELETEPRODUCTCART:
      return state.filter(
        (item) => item?.productId !== action.payload?.productId
      );
    case INCREASEQUANTITY:
      const { productId2 = productId, quantity2 = quantity } = action.payload;
      return state.map((product) => {
        if (product.productId !== productId2) {
          return product;
        }
        return {
          ...product,
          quantity: +quantity2 + 1,
        };
      });

    default:
      return state;
  }
};

export default cartReducer;
